import { useMsal } from "@azure/msal-react";

import { useGetApiProjectsQuery, usePutApiProjectsByProjectIdHideMutation, usePutApiProjectsByProjectIdUnhideMutation } from "api/generatedApi";
import { ScreenSizeEnum, useScreenSize } from "shared/use-screen-size";
import { DesktopAccountPage } from "./desktop-account";
import { MobileAccountPage } from "./mobile-account";
import { RouteSubPage } from "shared/route-types";
import { ProjectsContext } from "../../components/page/account/contexts/project-context";

interface Props {
  subPage: RouteSubPage;
}

export const DefaultAccountPage = (props: Props) => {
  const { subPage } = props;
  const { data: projects, error: projectError, refetch } = useGetApiProjectsQuery({ showHiddenProjects: true });

  const [hideProjectMutationAPI] = usePutApiProjectsByProjectIdHideMutation();
  const [unhideProjectMutationAPI] = usePutApiProjectsByProjectIdUnhideMutation();

  const handleRefetchProjects = () => {
    refetch();
  };

  const hideProjectMutation = async (projectId: string) => {
    await hideProjectMutationAPI({ projectId });
  };

  const unhideProjectMutation = async (projectId: string) => {
    await unhideProjectMutationAPI({ projectId });
  };

  const { screenSize } = useScreenSize();

  return (
    <ProjectsContext.Provider value={{ projects, hideProjectMutation, unhideProjectMutation, refetchProjects: handleRefetchProjects }}>
      {screenSize === ScreenSizeEnum.Mobile ? <MobileAccountPage subPage={subPage} /> : <DesktopAccountPage subPage={subPage} />}
    </ProjectsContext.Provider>
  );
};
